import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Block, Button } from '../../../Component';
import CardTabs from '../../../../pages/components/cards/CardTabs';
import { useDispatch, useSelector } from 'react-redux';
import { ADMIN_RETRIEVE_SMS_PORTAL_SETTINGS_API } from '../../../../api/api_data';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_tenant_sms_portal_settings, loading_retrieve_tenant_sms_portal_settings, reset_retrieve_tenant_sms_portal_settings, success_retrieve_tenant_sms_portal_settings } from '../../../../reducers/auth_tenant/retrieve_tenant_sms_portal_settings_Slice';
import { TENANT_COULD_NOT_RETIREVE_SETTINGS_ERROR_MSG, TENANT_COULD_NOT_RETIREVE_SETTINGS_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { messageToast } from '../../../../utils/Utils';
import * as app_consts from "../../../../utils/app_consts";
import AdminAddTenantSMSProviderModal from './AdminAddTenantSMSProviderModal';

const AdminViewTenantBulkSMSPortalModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

  const [open, setOpen] = useState(isOpen);
  const [page_data, setPageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [activeCardTab, setActiveCardTab] = useState("SMS Providers");
  const [sent_data, setSentData] = useState(data);
  const [add_sms_provider_modal, setAddSMSProviderModal] = useState(false);


  const open_add_sms_provider_modal = () => {
    setAddSMSProviderModal(true);
  };

  const close_add_sms_provider_modal = () => {
    setAddSMSProviderModal(false);
  };

  const add_sms_provider_modal_successFunction = () => {
    retrieve_data(sent_data?.tenant?.id);
  };

  // Card Tabs
  const tabs = [
    {
      tabName: "SMS Providers"
    },
    {
      tabName: "Numbers Regex Setup"
    },
    {
      tabName: "Module Setup"
    }
  ];

  useEffect(() => {
    setError("");
    setSentData(data);
    setOpen(isOpen);
    if (isOpen && data)
    {
      retrieve_data(data?.tenant?.id);
    }
  }, [isOpen, data]);

  const retrieve_data = (id) => {
    setError("");
    // Retreive Employees
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_sms_portal_settings, success_retrieve_tenant_sms_portal_settings, fail_retrieve_tenant_sms_portal_settings, TENANT_COULD_NOT_RETIREVE_SETTINGS_ERROR_MSG, TENANT_COULD_NOT_RETIREVE_SETTINGS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${ADMIN_RETRIEVE_SMS_PORTAL_SETTINGS_API}/${id}`));
  };

  // Listener
  const retrieve_tenant_sms_portal_settings_listener = useSelector((state) => state.retrieve_tenant_sms_portal_settings.retrieve_tenant_sms_portal_settings);

  useEffect(() => {
    if (retrieve_tenant_sms_portal_settings_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_sms_portal_settings_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_sms_portal_settings_listener.status === app_consts.FAIL)
        {
          setError(retrieve_tenant_sms_portal_settings_listener.message);
          messageToast(retrieve_tenant_sms_portal_settings_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_sms_portal_settings_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_sms_portal_settings_listener.data);
        }
        setLoading(false);
        dispatch(reset_retrieve_tenant_sms_portal_settings());
      }
    }
  }, [retrieve_tenant_sms_portal_settings_listener]);



  return (
    <>
      <Modal isOpen={open} toggle={loading ? "" : closeModal} className="modal-dialog-centered" size={"xl"} fullscreen>
        <ModalHeader toggle={loading ? "" : closeModal}>SMS Portal</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieveing SMS Portal Settings...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 16, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      {
                        page_data && page_data?.message === 'No SMS Portal Settings Found' ? (
                          <>
                            <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                              <div className="text-soft fw-bold my-4" style={{ fontSize: 18 }}>No SMS Portal Settings Found</div>
                              <Button onClick={(e) => open_add_sms_provider_modal()} color="primary" size="sm">
                                Add SMS Portal Settings
                              </Button>
                            </div>
                          </>
                        )
                          :
                          <>
                            <Block>
                              <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                            </Block>
                            {
                              activeCardTab === "SMS Providers" && (
                                <>

                                </>
                              )
                            }
                          </>
                      }

                      <AdminAddTenantSMSProviderModal tenant_info={tenant_info} user_info={user_info} isOpen={add_sms_provider_modal} successFunction={add_sms_provider_modal_successFunction} closeModal={closeModal} data={sent_data} />
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>

    </>
  );
};

export default AdminViewTenantBulkSMSPortalModal;